import gql from "graphql-tag";

export const SEND_GIFT_CARD = gql`
  mutation ($input: sendGiftCardInput) {
    sendGiftCard(input: $input)
  }
`;
